import React, { ReactNode } from 'react';
import { ThemeProvider, defaultTheme, MobileThemeProvider, MobileMode } from '@amzn/storm-ui';
import { StyleSheetManager, StylisPlugin } from 'styled-components';
import rtlPlugin from 'stylis-plugin-rtl';
import { AccountContextProvider } from './AccountContextProvider';

function NoopPlugin() {}
Object.defineProperty(NoopPlugin, 'name', { value: 'aac-ccx-interstitial' });

const theme = {
  ...defaultTheme,
  modal: {
    ...defaultTheme.modal,
    zIndex: 799
  }
}
interface AppWrapperProps {
  isMobile: boolean;
  children: ReactNode;
}

export const AppWrapper: React.FC<AppWrapperProps> = ({isMobile,children}) => {
  return (
    <AccountContextProvider>
      <ThemeProvider theme={theme}>
        <MobileThemeProvider
            mobileMode={
              isMobile
                ? MobileMode.Enable
                : MobileMode.Disable
            }
          >
            <StyleSheetManager
              stylisPlugins={
                (document.documentElement.dir === 'rtl'
                  ? [rtlPlugin, NoopPlugin]
                  : [NoopPlugin]) as StylisPlugin[]
              }
            >
              {children}
            </StyleSheetManager>
          </MobileThemeProvider>
      </ThemeProvider>
    </AccountContextProvider>
  );
};
